export default "__VITE_ASSET__CKwbhejj__"